import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { Alert } from '../models/alert.model';
import { AlertEnum, DialogEnum } from '../enumerators/messages.enum';
import { Info } from '../models/info.model';
import { Dialog } from '../models/dialog.model';
import { DialogResponse } from '../models/dialog-response.model';
import { DialogOption } from '../models/dialog-option.model';
import { Language } from '../models/language.model';
import { SelectableOption } from '../components/messages/option-selector-dialog/option-selector-dialog.component';

@Injectable()

export class MessageService {
    private alertSubject = new Subject<any>();
    private timerAlertSubject = new Subject<any>();
    private infoSubject = new Subject<any>();
    private dialogSubject = new Subject<any>();
    private optionSelectorSubject = new Subject<any>();
    private id: number = 0;

    private dialogResponse: any;
    private timerAlertResponse: any;
    private optionSelectorResponse: any;

    constructor() {
    }

    //-- Alerta --
    startAlert(): Observable<any> {
        return this.alertSubject.asObservable();
    }

    alert(type: AlertEnum, description: string, remove = true) {
        this.id++;
        this.alertSubject.next(<Alert>{ type: type, description: description, alertId: this.id, remove: remove, icon: "" });
    }

    stopAlert(stoped: boolean) {
        this.timerAlertResponse.resolve(stoped);
    }

    //-- Alerta Timer --
    startTimerAlert(): Observable<any> {
        return this.timerAlertSubject.asObservable();
    }

    timerAlert(type: AlertEnum, description: string, time = 0) {
        this.timerAlertResponse = new DialogResponse<boolean>();

        this.timerAlertSubject.next(<Alert>{ type: type, description: description, alertId: this.id, timer: time });

        return this.timerAlertResponse.promise;
    }

    //-- Mensaje Información --
    startInfoMessage() {
        return this.infoSubject.asObservable();
    }

    message(info: Info) {
        this.infoSubject.next(info);
    }

    //-- Dialogos --
    startDialog() {
        return this.dialogSubject.asObservable();
    }

    dialog(type: DialogEnum, title: string, message: string, option: Array<DialogOption>) {
        this.dialogResponse = new DialogResponse<boolean>();

        this.dialogSubject.next(new Dialog({ type: type, title: title, message: message, options: option }));

        return this.dialogResponse.promise;
    }

    sendDialogResponse(response: any) {
        this.dialogResponse?.resolve(response);
    }

        //-- Diálogo Selector de Opciones --
    startOptionSelectorDialog() {
        return this.optionSelectorSubject.asObservable();
    }

    optionSelectorDialog(type: DialogEnum, title: string, message: string, options: SelectableOption[], showCancelButton: boolean = true, defaultColor?: string) {
        this.optionSelectorResponse = new DialogResponse<number | null>();

        this.optionSelectorSubject.next({
            dialog: new Dialog({ type: type, title: title, message: message, options: [] }),
            options: options,
            showCancelButton: showCancelButton,
            defaultColor: defaultColor
        });

        return this.optionSelectorResponse.promise;
    }

    sendOptionSelectorResponse(optionId: number | null) {
        this.optionSelectorResponse?.resolve(optionId);
    }
}
